import { connect } from "react-redux";
import get from "lodash/get";

import { getOwnershipAreas as onGetOwnershipAreas } from "../../actions/ownershipAreasActions";

const mapStateToProps = (state) => ({
  dataState: state.userOwnershipAreas.dataState,
  ownershipAreas: get(state, ["userOwnershipAreas", "ownershipAreas"], []),
  errors: get(state, ["userOwnershipAreas", "errors"], null),
});

const mapDispatchToProps = { onGetOwnershipAreas };

const withOwnershipAreas = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withOwnershipAreas };
